import gql from 'graphql-tag';

const updatePurchaseOrderIdMutation = gql`
  mutation updatePurchaseOrderId(
    $versionId: String!
    $purchaseOrderId: String!
  ) {
    updatePurchaseOrderId(
      versionId: $versionId
      purchaseOrderId: $purchaseOrderId
    ) {
      purchaseOrderId
      versionId
    }
  }
`;

const updatePurchaseOrderId = () => ({
  mutation: updatePurchaseOrderIdMutation,
  module: 'video',
  buildVariables: ({
    versionId,
    purchaseOrderId



  }) => ({
    versionId,
    purchaseOrderId
  })
});

export default updatePurchaseOrderId;